/**
 * The default timeout to set when using the global live message
 * to read a loading state.
 * This is to ensure that the loading state is not read if the results are displayed
 * fast enough.
 */
export const DEFAULT_LOADING_LIVE_MESSAGE_TIMEOUT = 500;
